import { trimEnd } from "./string-helpers.js";
/**
 * @param model
 * @param maxSportTypes
 */
export function getSportTypesText(model, maxSportTypes = 3) {
    if (!model || !model.sportTypes || !model.sportTypes.length) {
        return null;
    }
    let separator = ' | ';
    let sportTypesText = '';
    for (let i = 0; i < (model.sportTypes.length > maxSportTypes ? (maxSportTypes - 1) : model.sportTypes.length); i++) {
        sportTypesText += model.sportTypes[i].name + separator;
    }
    if (model.sportTypes.length > maxSportTypes) {
        sportTypesText += '+ ' + (model.sportTypes.length - (maxSportTypes - 1)).toString();
    }
    sportTypesText = trimEnd(sportTypesText, separator);
    return sportTypesText;
}
/**
 * @param model
 * @param withStreet
 */
export function getAddressText(model, withStreet = true) {
    if (!model) {
        return null;
    }
    let address = [];
    if (withStreet && model.street) {
        address.push(model.street);
    }
    if (model.postcode) {
        let cityLocation = model.postcode;
        if (model.city) {
            cityLocation += ' ' + model.city;
        }
        address.push(cityLocation);
    }
    else if (model.city) {
        address.push(model.city);
    }
    if (model.country_code) {
        address.push(model.country ? model.country.locale_name : model.country_code.toUpperCase());
    }
    return address.length ? address.join(', ') : null;
}
//# sourceMappingURL=main-model-helpers.js.map